import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FbSwitchButtonComponent } from './fb-switch-button.component';
import { InputSwitchModule } from 'primeng/inputswitch';

@NgModule({
  imports: [
    CommonModule,
    InputSwitchModule
  ],
  declarations: [FbSwitchButtonComponent],
  exports: [FbSwitchButtonComponent]
})
export class FbSwitchButtonModule { }
